<script setup lang="ts">
defineProps<{ episode: PodcastRssEpisode | undefined }>()
</script>

<template>
  <div v-if="episode" class="flex flex-col gap-3xs">
    <span class="text-xs lg:title-s !font-light">Episode {{ episode.number }}</span>

    <h2
      v-if="episode.title"
      class="title-xs lg:title-m"
      v-html="episode.title"
    />
  </div>
</template>
